import React, { Fragment } from 'react';
import { Form, Input } from 'antd';

const GarageNumber = ({ form, disabled}) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">
        Гаражный (внутренний)
        <br /> номер (при наличии):
      </span>
      <Form.Item>
        {getFieldDecorator('garageNum')(
          <Input
            placeholder="Укажите гаражный номер"
            className="basicInput"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <div></div>
    </Fragment>
  );
};

export default GarageNumber;
